export default __webpack_public_path__ + "static/media/Note_5_img.15030575.jpg";